import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import {FontLoader, TextGeometry} from "three/addons";
import colorSpaceNode from "three/src/nodes/display/ColorSpaceNode.js";

/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()



const matcapTexture1 = textureLoader.load('./textures/matcaps/1.png')
const matcapTexture2 = textureLoader.load('./textures/matcaps/2.png')
const matcapTexture3 = textureLoader.load('./textures/matcaps/3.png')
const matcapTexture4 = textureLoader.load('./textures/matcaps/4.png')
const matcapTexture5 = textureLoader.load('./textures/matcaps/5.png')
const matcapTexture6 = textureLoader.load('./textures/matcaps/6.png')
const matcapTexture7 = textureLoader.load('./textures/matcaps/7.png')
const matcapTexture8 = textureLoader.load('./textures/matcaps/8.png')

const matcaps = [
    matcapTexture1,
    matcapTexture2,
    matcapTexture3,
    matcapTexture4,
    matcapTexture5,
    matcapTexture6,
    matcapTexture7,
    matcapTexture8
];

matcaps.forEach(tex => tex.colorSpace = THREE.SRGBColorSpace);

const fontLoader = new FontLoader()

fontLoader.load('./fonts/helvetiker_regular.typeface.json', (font) => {
    const textGeometry = new TextGeometry(
        'CRYPTONISLAB',
        {
            font: font,
            size: 0.5,
            depth: 0.2,
            curveSegments: 6,
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.02,
            bevelOffset: 0,
            bevelSegments: 4
        }
    )

    textGeometry.center()


    const textMaterial = new THREE.MeshMatcapMaterial( { matcap: matcapTexture8 } )
    const text = new THREE.Mesh(textGeometry, textMaterial)
    scene.add(text)

    const words = [
        "Bitcoin",
        "Ethereum",
        "Uniswap",
        "Solana",
        "TON",
        "Metamask",
        "Tether",
        "TRON",
        "XRP",
        "Litecoin",
        "SHIB",
        "LEO",
        "Coinbase",
        "Binance",
        "OKX",
        "ADA",
        "BNB",
        "DOT",
        "LINK",
        "XLM",
        "XMR"
    ];

    function getRandomWord() {
        return words[Math.floor(Math.random() * words.length)];
    }

    function getRandomMatcap() {
        return matcaps[Math.floor(Math.random() * matcaps.length)];
    }

    for (let i = 0; i < 100; i++) {
        const randomText = getRandomWord();

        const bitcoinGeometry = new TextGeometry(
            randomText.toUpperCase(),
            {
                font: font,
                size: 0.3,
                depth: 0.1,
                curveSegments: 6,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.02,
                bevelOffset: 0,
                bevelSegments: 4
            }
        )

        const textMaterial = new THREE.MeshMatcapMaterial({
            matcap: getRandomMatcap()
        });

        const text = new THREE.Mesh(bitcoinGeometry, textMaterial)

        text.userData = { url: `https://www.google.com/search?q=${randomText}+crypto` }




        text.position.set((Math.random()  - 0.5) * 10, (Math.random() - 0.5) * 10, (Math.random() - 0.5) * 10)
        text.rotation.set(Math.random() * 2 * Math.PI, Math.random() * 2 * Math.PI, 0)

        const scale = Math.random()
        text.scale.set(scale, scale, scale)
        scene.add(text)
    }


})


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 10
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const raycaster = new THREE.Raycaster()
const mouse = new THREE.Vector2()

window.addEventListener('click', (event) => {
    // 1. Нормализуем координаты мыши (от -1 до 1)
    mouse.x = (event.clientX / sizes.width) * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 + 1

    // 2. Направляем луч из камеры
    raycaster.setFromCamera(mouse, camera)

    // 3. Проверяем пересечения со всеми объектами сцены
    const intersects = raycaster.intersectObjects(scene.children)

    if (intersects.length > 0) {
        // Берем первый (ближайший) объект, на который кликнули
        const clickedObject = intersects[0].object

        // Проверяем, есть ли у объекта сохраненная ссылка
        if (clickedObject.userData && clickedObject.userData.url) {
            // Открываем ссылку в новой вкладке
            window.open(clickedObject.userData.url, '_blank')
        }
    }
})

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()